import { makeImmutable } from "../../core/makeImmutable";
import { Availability } from "../Availability";
import { ParameterScope } from "../ParameterScope";
import { CustomParameterSet, ParameterSet } from "../ParameterSet";
import { Price } from "../Price";
export class ProductInstanceVariant {
    constructor(params) {
        this.id = params.id;
        this.productType = params.productType;
        this.customParameterChoices = params.customParameterChoices;
        this.scope = ParameterScope.fromParameterSet(new ParameterSet({
            custom: this.customParameterChoices,
        }));
        makeImmutable(this);
    }
    get price() {
        return Price.scoped(this.productType.pricing, this.scope);
    }
    get availability() {
        return Availability.ofProductType(this.productType, this.scope);
    }
    get divisibleCustomParameterChoices() {
        return CustomParameterSet.fromChoices(this.customParameterChoices.choices.filterWithKey((parameterType) => parameterType.isDivisible));
    }
    get nonDivisibleCustomParameterChoices() {
        return CustomParameterSet.fromChoices(this.customParameterChoices.choices.filterWithKey((parameterType) => !parameterType.isDivisible));
    }
}
